import { render, staticRenderFns } from "./dictamen-diaspora.vue?vue&type=template&id=5590fc61&"
import script from "./dictamen-diaspora.component.ts?vue&type=script&lang=ts&"
export * from "./dictamen-diaspora.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports